//APIS NAMES => DHBOSS & INVINCIBLE
import React, { useEffect, useState } from "react";
import Header from "../Header";
import {
  shareIphonePostMsg,
  Toast,
  Userlogin,
} from "../Utils/general-function";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../Utils/Loader";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

function CheckRC(props) {
  const [loading, setLoading] = useState(false);
  const [searchtxt, setSearchtxt] = useState("");
  const [Details, setDetails] = useState({});
  const [Code, setCode] = useState();
  const [abortController, setAbortController] = useState(null);
  const [isRequestPending, setIsRequestPending] = useState(false);
  const [Member, setMember] = useState(null);
  const [apiSource, setApiSource] = useState(null);
  const navigate = useNavigate();

  const iphone = window.navigator.userAgent.includes("Mac");
  const OnChange = (e) => {
    setSearchtxt(e.target.value.toUpperCase());
  };

  const Status = {
    A: "Active",
    Y: "Active",
    D: "RC Suspended",
    C: "RC Cancel",
    S: "RC Surrender",
    T: "Scrap Vehicle",
    V: "Vehicle Scrapped RC Cancel",
    Z: "Vehicle Submitted For Scrapping",
    ACTIVE: "Active",
  };

  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
      return;
    }
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      },
    };
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/ActiveMemberCriteria/MemberActiveornotdata",
      header,
    )
      .then((response) => response.json())
      .then((res) => {
        setMember(res);
        console.log("member", res);
      });
  }, []);

  const onSubmit = () => {
    const div = document.getElementById("result");
    const btndiv = document.getElementById("btndiv");

    if (
      Member.Message === "Active" ||
      localStorage.getItem("loginMobile") === "7069905525" // for me only withoiut limit
    ) {
      fetchApi(div, btndiv);
    } else {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="popup-overlay px-3 py-3 text-center">
              <div className="text-start">
                <p>
                  To access this service, we kindly request that you add{" "}
                  <b>
                    {parseInt(Member.Data.VehicleinPortfolio) -
                      parseInt(Member.Data.noofcar)}
                  </b>{" "}
                  vehicles to your portfolio.
                </p>
              </div>
              <button
                className="submitbtn me-2 popup-btn"
                onClick={() => {
                  onClose();
                }}
              >
                Ok
              </button>
            </div>
          );
        },
      });
    }
  };

  // const newapi=()=>{
  //   const options = {
  //     method: 'POST',
  //     headers: {
  //       accept: 'application/json',
  //       Token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0aW1lc3RhbXAiOjE2ODAwNjc3MjcsInBhcnRuZXJJZCI6IkNPUlAwMDAwMSIsInJlcWlkIjoia2V5NTg3MDQwIn0.uSFJwpuFC2a0vaybRHGZ2RI1C9fvzF2pqJ0Qr7qa1Nk',
  //       'Content-Type': 'application/json',
  //       authorisedkey: 'TVRJek5EVTJOelUwTnpKRFQxSlFNREF3TURFPQ=='
  //     },
  //     body: JSON.stringify({refid: searchtxt})
  //   };

  //   fetch('https://uat.paysprint.in/sprintverify-uat/api/v1/verification/rc_verify', options)
  //     .then(response => response.json())
  //     .then(response => console.log("newapi",response))
  //     .catch(err => console.error(err));
  // }

  const fetchApi = async (div, btndiv) => {
    if (!String(searchtxt)?.trim()) {
      return Toast(false, "", "Please enter vehicle number");
    }
    setLoading(true);
    if (isRequestPending) return;
    if (abortController) {
      abortController.abort(); // Cancel the previous request
    }

    const controller = new AbortController();
    setAbortController(controller);
    setIsRequestPending(true);
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      },
      signal: controller.signal,
    };
    try {
      ///api/RCHistory/TestGetRCHistory?Carno=
      const response = await fetch(
        process.env.REACT_APP_API_ENDPOINT +
          "/api/RCHistory/DaynamicRCHistory?Carno=" +
          searchtxt,
        header,
      );
      const res = await response.json();

      div.style.display = "block";
      let data = JSON.parse(res.Data);
      console.log("res", res);

      if (res.Success !== true) {
        //const result = JSON.parse(res.Data);
        setCode(500);
        if (res.Message === "Authorization has been denied for this request") {
          navigate("/login");
        } else if (res.Message === "Cross limit") {
          setDetails({
            message:
              "You have reached your daily limit. You can perform up to 20 RC searches per day.",
          });
          return;
        }
        throw new Error("BACKEND Api error");
      }
      if (res?.FrameData === "DHBOSS") {
        if (data?.status === "Failure") {
          Toast(false, "", data?.message || "Something went wrong");
          throw new Error("DHBOSS Api error");
        }
        setDetails(data?.detail || {});
      } else if (res?.FrameData === "INVINCIBLE") {
        if (data?.code && Number(data?.code) !== 200) {
          Toast(false, "", data?.message || "Something went wrong");
          throw new Error("INVINCIBLE Api error");
        }
        setDetails(data?.data || {});
      }
      btndiv.style.display = "flex";
      setCode(200);
      setApiSource(res?.FrameData);
    } catch (error) {
      btndiv.style.display = "none";
      setLoading(false);
      setCode(null);
      setDetails(null);
      console.error("Fetch error:", error);
    } finally {
      setIsRequestPending(false);
      setLoading(false);
    }
  };

  function maskName(name) {
    let maskedName = "";
    for (let i = 0; i < name.length; i++) {
      if (i % 2 === 0) {
        maskedName += name[i];
      } else {
        maskedName += "*";
      }
    }
    return maskedName;
  }

  function replaceLastFiveCharacters(str) {
    return str?.length > 5 ? str.slice(0, -5) + "XXXXX" : "XXXXX";
  }
  const download = async () => {
    setLoading(true);
    const div = document.getElementById("result");
    let filename = searchtxt + ".pdf";

    const options = {
      // pagebreak:{ mode: ['avoid-all', 'css', 'legacy'] },
      margin: [2, 10, 5, 10],
      // margin: [2, 10, 5, 0],
      filename,
      image: {
        type: "jpeg",
        quality: 1.0,
      },
      html2canvas: {
        scale: 2,
        dpi: 192,
        letterRendering: true,
        allowTaint: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compress: true,
      },
    };
    if (iphone) {
      let bs64 = await html2pdf()
        .from(div)
        .set(options)
        .toPdf()
        .output("datauristring");
      await shareIphonePostMsg({ data: bs64, filename, action: "sharebase64" });
      return;
    }
    await html2pdf().from(div).set(options).toPdf().get("pdf").save();
    setLoading(false);
  };

  const share = async () => {
    const div = document.getElementById("result");
    const scale = 3;
    const a4Width = 2480; // A4 width in pixels (fixed) 300dpi
    const a4Height = 3508; // Default A4 height in pixels
    const contentHeight = div.scrollHeight; // Actual content height

    // Set canvas height: Use A4 height OR extend to fit content
    const finalHeight = contentHeight > a4Height ? contentHeight : a4Height;

    const canvas = await html2canvas(div, {
      scale,
      useCORS: true, // Ensures images are captured properly
      windowHeight: finalHeight,
      windowWidth: a4Width,
    });
    const imgData = await canvas.toDataURL();

    let filename = searchtxt + ".png";
    if (iphone) {
      return shareIphonePostMsg({
        data: imgData,
        action: "sharebase64",
        filename,
      });
    }
    const blob = await (await fetch(imgData)).blob();
    const filesArray = [
      new File([blob], filename, {
        type: "image/png",
        lastModified: new Date().getTime(),
      }),
    ];
    if (navigator.canShare && navigator.canShare({ files: filesArray })) {
      navigator
        .share({
          files: filesArray,
        })

        .then(() => console.log("Share was successful."))

        .catch((error) => console.log("Sharing failed", error));
    } else {
      console.log(`Your system doesn't support sharing files.`);
    }
  };

  const greenClr = "#3d903dff";
  const redClr = "#E62E2D";

  const showRcResult = (apiSource) => {
    switch (apiSource) {
      case "DHBOSS":
        //DH BOSS

        return (
          <>
            <div className="rc-div">
              <span className="rc-property">Vehicle Number </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "700" }}>
                {Details?.registrationNumber}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Status
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{
                  fontWeight: "500",
                  color: ["ACTIVE", "A", "Y"].includes(Details?.rcStatus)
                    ? greenClr
                    : redClr,
                }}
              >
                {Details && Status[Details?.rcStatus]}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Financed</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.hypothecation === false ? "No" : "Yes"}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Insurance Company</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.insuranceCompany}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Insurance Upto</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {new Date(Details?.insuranceUpTo).toLocaleDateString("es-CL")}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">PUCC Valid Upto</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {new Date(Details?.pucUpTo).toLocaleDateString("es-CL")}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Maker Model</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.rc_model}
              </span>
            </div>
            {/* <div className="rc-div">
              <span className="rc-property">Vehicle Class</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
               { Details?.vehicle_category}
              </span>
            </div>  */}
            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Owner Number
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.rc_owner_sr}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Owner</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.rc_owner_name_masked}
              </span>
            </div>

            {Details?.chassisNo && (
              <div className="rc-div">
                <span className="rc-property">Chassis Number</span>
                <span className="w-10">:</span>
                <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                  {Details?.chassisNo}
                </span>
              </div>
            )}
            {Details?.engineNo && (
              <div className="rc-div">
                <span className="rc-property">Engine Number</span>
                <span className="w-10">:</span>
                <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                  {Details?.engineNo}
                </span>
              </div>
            )}
            <div className="rc-div">
              <span className="rc-property">Fuel Type </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.fuelType}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Color</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.color}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Manufactured on
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.manufacturingMonthYr}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Registered Date </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {new Date(Details?.registeredAt).toLocaleDateString("es-CL")}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Tax Paid Upto</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.taxUpTo
                  ? new Date(Details?.taxUpTo)?.toLocaleDateString("es-CL")
                  : "-"}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">RTO </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.registeredPlace}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Seating Capacity</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.ds_details?.[0]?.variant?.variant_display_name ??
                  Details?.ds_details?.[0]?.variant?.variant_name}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Noc Details</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.rtoNocIssued === "false"
                  ? "NOC Not Issued"
                  : "NOC Issued"}
              </span>
            </div>
          </>
        );

      case "INVINCIBLE":
        // INVICIBLE
        return (
          <>
            <div className="rc-div">
              <span className="rc-property">Vehicle Number </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "700" }}>
                {Details?.regNo}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Status
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{
                  fontWeight: "500",
                  color: ["ACTIVE", "A", "Y"].includes(Details?.status)
                    ? greenClr
                    : redClr,
                }}
              >
                {Details && Status[Details?.status]}
              </span>
            </div>

            <div className="rc-div">
              <span className="rc-property">Financed</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.financed?.toString()
                  ? Details?.financed?.toString()
                  : "-"}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Financer
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.rcFinancer ? Details?.rcFinancer : "-"}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Insurance Company</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.vehicleInsuranceCompanyName}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Insurance Policy Number</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.vehicleInsurancePolicyNumber
                  ? Details?.vehicleInsurancePolicyNumber
                  : "Not available"}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Insurance Upto</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {new Date(Details?.vehicleInsuranceUpto)?.toLocaleDateString(
                  "es-CL",
                )}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">PUCC Valid Upto</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.puccUpto}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Maker Model</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.model}
              </span>
            </div>
            {/* <div className="rc-div">
              <span className="rc-property">Vehicle Class</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
               { Details?.vehicle_category}
              </span>
            </div>  */}
            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Owner Number
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.ownerCount}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Owner</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.owner ? maskName(Details?.owner) : ""}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Father Name</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.ownerFatherName
                  ? maskName(Details?.ownerFatherName)
                  : "-"}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Chassis Number</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {replaceLastFiveCharacters(Details?.chassis)}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Engine Number</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {replaceLastFiveCharacters(Details?.engine)}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Fuel Type </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.type}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Color</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.vehicleColour}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Emission Norm</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.normsType}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property" style={{ fontWeight: "700" }}>
                Manufactured on
              </span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {Details?.vehicleManufacturingMonthYear}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Registered Date </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {new Date(Details?.regDate).toLocaleDateString("es-CL")}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Expiry Date</span>
              <span className="w-10">:</span>
              <span
                className="title ps-2 w-45"
                style={{ fontWeight: "500", color: redClr }}
              >
                {new Date(Details?.rcExpiryDate).toLocaleDateString("es-CL")}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Tax Paid Upto</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.vehicleTaxUpto}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">RTO </span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.regAuthority}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Cubic Capacity</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.vehicleCubicCapacity}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Seating Capacity</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.vehicleSeatCapacity
                  ? Details?.vehicleSeatCapacity
                  : "-"}
              </span>
            </div>
            <div className="rc-div">
              <span className="rc-property">Noc Details</span>
              <span className="w-10">:</span>
              <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
                {Details?.nocDetails ? Details?.nocDetails : "-"}
              </span>
            </div>
          </>
        );

      default:
        break;
    }
  };
  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}
      <div className="text-center">
        <h2 className="page-title">Vehicle RC Check</h2>
      </div>
      <div className="page-space">
        <div className="input-group mt-2">
          <input
            type="text"
            className="form-control"
            placeholder="RC Number"
            name="searchtxt"
            value={searchtxt}
            onChange={OnChange}
          />
          <button
            className="btn rc-submit"
            type="submit"
            onClick={(e) => onSubmit()}
          >
            Submit
          </button>
        </div>

        <div
          className="justify-content-center pt-3"
          id="btndiv"
          style={{ display: "none" }}
        >
          <button className="cardoc-btn" onClick={(e) => download()}>
            <img
              src="assets/images/download-icon.svg"
              alt="Download"
              style={{ width: "32px", backgroundColor: "transparent" }}
            />
          </button>
          <button className="cardoc-btn">
            <img
              src="assets/images/share-d.png"
              alt="share"
              style={{ width: "32px" }}
              onClick={(e) => share()}
            />
          </button>
        </div>

        <div
          className="my-3 rc-details p-3"
          id="result"
          style={{ display: "none" }}
        >
          <div className="d-flex text-center justify-content-around flex-column">
            <span className="logodiv">
              <img src="assets/images/logo.png" alt="" />
            </span>
            <span
              className="title ps-4 "
              style={{ paddingTop: "2px", fontWeight: "700" }}
            >
              {" "}
              Vehicle Registration
            </span>
          </div>

          {Code === 200 ? (
            <div className="mt-4 d-grid gap-2" id="cardetails">
              {showRcResult(apiSource)}
              {/* TOP SERVICE */}
              <span
                className="title  text-center d-flex  justify-content-center flex-column"
                style={{ paddingTop: "2px", fontWeight: "700", color: redClr }}
              >
                Top Services
              </span>

              <div className="rc-div rc-gird-2">
                <Link
                  to="/MakeCustomizepost"
                  className="d-flex align-items-start gap-1"
                >
                  <i
                    className="bx bx-check"
                    style={{
                      maxHeight: "16px",
                      marginTop: "3px",
                      color: redClr,
                      fontWeight: "bold",
                    }}
                  ></i>
                  <span className="rc-property w-100">
                    Create Professional Social Media Post
                  </span>
                </Link>
                <Link className="d-flex align-items-start gap-1">
                  <i
                    className="bx bx-check"
                    style={{
                      maxHeight: "16px",
                      marginTop: "3px",
                      color: redClr,
                      fontWeight: "bold",
                    }}
                  ></i>
                  <span className="rc-property w-100">Carthi Perfume</span>
                </Link>
              </div>
              {/* carthi sites */}
              <div className="rc-gird-2 border-0">
                <a
                  href="https://m.carthi.in/"
                  className="d-flex align-items-center "
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="d-flex justify-content-left align-items-center">
                    <span
                      className="rc-property w-100"
                      style={{
                        color: redClr,
                      }}
                    >
                      m.carthi.in
                    </span>
                    <span
                      class="material-symbols-outlined"
                      style={{ fontSize: "16px" }}
                    >
                      arrow_outward
                    </span>
                  </div>
                </a>
                <a
                  href="https://carthi.in/"
                  className="d-flex align-items-center "
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="d-flex justify-content-left align-items-center">
                    <span
                      className="rc-property w-100"
                      style={{
                        color: redClr,
                      }}
                    >
                      carthi.in
                    </span>
                    <span
                      class="material-symbols-outlined"
                      style={{ fontSize: "16px" }}
                    >
                      arrow_outward
                    </span>
                  </div>
                </a>
              </div>
            </div>
          ) : (
            <div
              className="text-center mt-2"
              style={{ color: "#ff002a", fontWeight: "500" }}
            >
              <label>
                {Details?.message ||
                  "We're working on retrieving the information. Please check back shortly."}{" "}
              </label>
            </div>
          )}
        </div>

        {/* our services */}
        {Code !== 200 && (
          <>
            <div className="text-center">
              <h2 className="page-title">Top Services</h2>
            </div>
            <div className="our-service">
              <div
                className="cat-link d-block"
                style={{ margin: "0px 0px 15px 0px" }}
              >
                <Link
                  to="/MakeCustomizepost"
                  className="d-flex align-items-center gap-2"
                >
                  <img src="assets/images/design-template.png" alt="" />
                  <label>Create Professional Social Media Post</label>
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CheckRC;

// old with only one api result
// import React, { useEffect, useState } from "react";
// import Header from "../Header";
// import {
//   shareIphonePostMsg,
//   Toast,
//   Userlogin,
// } from "../Utils/general-function";
// import { Link, useNavigate } from "react-router-dom";
// import Loader from "../Utils/Loader";
// import html2pdf from "html2pdf.js";
// import html2canvas from "html2canvas";
// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";
// import { toBlob } from "html-to-image";

// function CheckRC(props) {
//   const [loading, setLoading] = useState(false);
//   const [searchtxt, setSearchtxt] = useState("");
//   const [Details, setDetails] = useState({});
//   const [Code, setCode] = useState();
//   const [abortController, setAbortController] = useState(null);
//   const [isRequestPending, setIsRequestPending] = useState(false);
//   const [Member, setMember] = useState(null);
//   const navigate = useNavigate();
//   const iphone = window.navigator.userAgent.includes("Mac");
//   const OnChange = (e) => {
//     setSearchtxt(e.target.value.toUpperCase());
//   };

//   const Status = {
//     A: "Active",
//     Y: "Active",
//     D: "RC Suspended",
//     C: "RC Cancel",
//     S: "RC Surrender",
//     T: "Scrap Vehicle",
//     V: "Vehicle Scrapped RC Cancel",
//     Z: "Vehicle Submitted For Scrapping",
//     ACTIVE: "Active",
//   };

//   useEffect(() => {
//     if (!Userlogin()) {
//       navigate("/Login");
//       return;
//     }
//     const header = {
//       headers: {
//         Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
//       },
//     };
//     fetch(
//       process.env.REACT_APP_API_ENDPOINT +
//         "/api/ActiveMemberCriteria/MemberActiveornotdata",
//       header,
//     )
//       .then((response) => response.json())
//       .then((res) => {
//         setMember(res);
//         console.log("member", res);
//       });
//   }, []);

//   const onSubmit = () => {
//     setLoading(true);
//     const div = document.getElementById("result");
//     const btndiv = document.getElementById("btndiv");

//     if (
//       Member.Message === "Active" ||
//       localStorage.getItem("loginMobile") === "7069905525" // for me only withoiut limit
//     ) {
//       fetchApi(div, btndiv);
//     } else {
//       setLoading(false);
//       confirmAlert({
//         customUI: ({ onClose }) => {
//           return (
//             <div className="popup-overlay px-3 py-3 text-center">
//               <div className="text-start">
//                 <p>
//                   To access this service, we kindly request that you add{" "}
//                   <b>
//                     {parseInt(Member.Data.VehicleinPortfolio) -
//                       parseInt(Member.Data.noofcar)}
//                   </b>{" "}
//                   vehicles to your portfolio.
//                 </p>
//               </div>
//               <button
//                 className="submitbtn me-2 popup-btn"
//                 onClick={() => {
//                   onClose();
//                 }}
//               >
//                 Ok
//               </button>
//             </div>
//           );
//         },
//       });
//     }
//   };

//   // const newapi=()=>{
//   //   const options = {
//   //     method: 'POST',
//   //     headers: {
//   //       accept: 'application/json',
//   //       Token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0aW1lc3RhbXAiOjE2ODAwNjc3MjcsInBhcnRuZXJJZCI6IkNPUlAwMDAwMSIsInJlcWlkIjoia2V5NTg3MDQwIn0.uSFJwpuFC2a0vaybRHGZ2RI1C9fvzF2pqJ0Qr7qa1Nk',
//   //       'Content-Type': 'application/json',
//   //       authorisedkey: 'TVRJek5EVTJOelUwTnpKRFQxSlFNREF3TURFPQ=='
//   //     },
//   //     body: JSON.stringify({refid: searchtxt})
//   //   };

//   //   fetch('https://uat.paysprint.in/sprintverify-uat/api/v1/verification/rc_verify', options)
//   //     .then(response => response.json())
//   //     .then(response => console.log("newapi",response))
//   //     .catch(err => console.error(err));
//   // }

//   const fetchApi = async (div, btndiv) => {
//     if (isRequestPending) return;
//     if (abortController) {
//       abortController.abort(); // Cancel the previous request
//     }

//     const controller = new AbortController();
//     setAbortController(controller);
//     setIsRequestPending(true);
//     const header = {
//       headers: {
//         Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
//       },
//       signal: controller.signal,
//     };
//     try {
//       const response = await fetch(
//         process.env.REACT_APP_API_ENDPOINT +
//           "/api/RCHistory/GetRCHistory?Carno=" +
//           searchtxt,
//         header,
//       );
//       const res = await response.json();

//       div.style.display = "block";
//       let data = JSON.parse(res.Data);

//       setDetails(data?.data);
//       if (res.Success === true) {
//         setCode(200);
//         btndiv.style.display = "flex";
//       } else {
//         //const result = JSON.parse(res.Data);
//         setCode(500);
//         if (res.Message === "Authorization has been denied for this request") {
//           navigate("/login");
//         } else if (res.Message === "Cross limit") {
//           setDetails({
//             message:
//               "You have reached your daily limit. You can perform up to 20 RC searches per day.",
//           });
//         }
//       }
//     } catch (error) {
//       console.error("Fetch error:", error);
//     } finally {
//       setIsRequestPending(false);
//       setLoading(false);
//     }
//   };

//   function maskName(name) {
//     let maskedName = "";
//     for (let i = 0; i < name.length; i++) {
//       if (i % 2 === 0) {
//         maskedName += name[i];
//       } else {
//         maskedName += "*";
//       }
//     }
//     return maskedName;
//   }

//   function replaceLastFiveCharacters(str) {
//     return str?.length > 5 ? str.slice(0, -5) + "XXXXX" : "XXXXX";
//   }
//   const download = async () => {
//     const div = document.getElementById("result");
//     let filename = searchtxt + ".pdf";

//     const options = {
//       // pagebreak:{ mode: ['avoid-all', 'css', 'legacy'] },
//       margin: [2, 10, 5, 10],
//       // margin: [2, 10, 5, 0],
//       filename,
//       image: {
//         type: "jpeg",
//         quality: 1.0,
//       },
//       html2canvas: {
//         scale: 2,
//         dpi: 192,
//         letterRendering: true,
//         allowTaint: true,
//       },
//       jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "portrait",
//         compress: true,
//       },
//     };
//     if (iphone) {
//       let bs64 = await html2pdf()
//         .from(div)
//         .set(options)
//         .toPdf()
//         .output("datauristring");
//       await shareIphonePostMsg({ data: bs64, filename, action: "sharebase64" });
//       return;
//     }
//     await html2pdf().from(div).set(options).toPdf().get("pdf").save();
//   };

//   const share = async () => {
//     const div = document.getElementById("result");
//     const scale = 3;
//     const a4Width = 2480; // A4 width in pixels (fixed) 300dpi
//     const a4Height = 3508; // Default A4 height in pixels
//     const contentHeight = div.scrollHeight; // Actual content height

//     // Set canvas height: Use A4 height OR extend to fit content
//     const finalHeight = contentHeight > a4Height ? contentHeight : a4Height;

//     const canvas = await html2canvas(div, {
//       scale,
//       useCORS: true, // Ensures images are captured properly
//       windowHeight: finalHeight,
//       windowWidth: a4Width,
//     });
//     const imgData = await canvas.toDataURL();

//     let filename = searchtxt + ".png";
//     if (iphone) {
//       return shareIphonePostMsg({
//         data: imgData,
//         action: "sharebase64",
//         filename,
//       });
//     }
//     const blob = await (await fetch(imgData)).blob();
//     const filesArray = [
//       new File([blob], filename, {
//         type: "image/png",
//         lastModified: new Date().getTime(),
//       }),
//     ];
//     if (navigator.canShare && navigator.canShare({ files: filesArray })) {
//       navigator
//         .share({
//           files: filesArray,
//         })

//         .then(() => console.log("Share was successful."))

//         .catch((error) => console.log("Sharing failed", error));
//     } else {
//       console.log(`Your system doesn't support sharing files.`);
//     }
//   };

//   const greenClr = "#3d903dff";
//   const redClr = "#E62E2D";
//   return (
//     <div>
//       <Header />
//       {loading ? <Loader /> : null}
//       <div className="text-center">
//         <h2 className="page-title">Vehicle RC Check</h2>
//       </div>
//       <div className="page-space">
//         <div className="input-group mt-2">
//           <input
//             type="text"
//             className="form-control"
//             placeholder="RC Number"
//             name="searchtxt"
//             value={searchtxt}
//             onChange={OnChange}
//           />
//           <button
//             className="btn rc-submit"
//             type="submit"
//             onClick={(e) => onSubmit()}
//           >
//             Submit
//           </button>
//         </div>

//         <div
//           className="justify-content-center pt-3"
//           id="btndiv"
//           style={{ display: "none" }}
//         >
//           <button className="cardoc-btn" onClick={(e) => download()}>
//             <img
//               src="assets/images/download-icon.svg"
//               alt="Download"
//               style={{ width: "32px", backgroundColor: "transparent" }}
//             />
//           </button>
//           <button className="cardoc-btn">
//             <img
//               src="assets/images/share-d.png"
//               alt="share"
//               style={{ width: "32px" }}
//               onClick={(e) => share()}
//             />
//           </button>
//         </div>

//         <div
//           className="my-3 rc-details p-3"
//           id="result"
//           style={{ display: "none" }}
//         >
//           <div className="d-flex text-center justify-content-around flex-column">
//             <span className="logodiv">
//               <img src="assets/images/logo.png" alt="" />
//             </span>
//             <span
//               className="title ps-4 "
//               style={{ paddingTop: "2px", fontWeight: "700" }}
//             >
//               {" "}
//               Vehicle Registration
//             </span>
//           </div>

//           {Code === 200 ? (
//             <div className="mt-4 d-grid gap-2" id="cardetails">
//               <div className="rc-div">
//                 <span className="rc-property">Vehicle Number </span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "700" }}>
//                   {Details?.regNo}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property" style={{ fontWeight: "700" }}>
//                   Status
//                 </span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{
//                     fontWeight: "500",
//                     color: ["ACTIVE", "A", "Y"].includes(Details?.status)
//                       ? greenClr
//                       : redClr,
//                   }}
//                 >
//                   {Details && Status[Details.status]}
//                 </span>
//               </div>
//               {/* <div className="rc-div">
//                 <span className="rc-property" style={{ fontWeight: "700" }}>
//                   Blacklist Status
//                 </span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {Details?.blacklist_status ? Details?.blacklist_status : "-"}
//                 </span>
//               </div> */}
//               <div className="rc-div">
//                 <span className="rc-property">Financed</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.financed?.toString()
//                     ? Details?.financed?.toString()
//                     : "-"}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property" style={{ fontWeight: "700" }}>
//                   Financer
//                 </span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {Details?.rcFinancer ? Details?.rcFinancer : "-"}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Insurance Company</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.vehicleInsuranceCompanyName}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Insurance Policy Number</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.vehicleInsurancePolicyNumber
//                     ? Details?.vehicleInsurancePolicyNumber
//                     : "Not available"}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Insurance Upto</span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {new Date(Details?.vehicleInsuranceUpto).toLocaleDateString(
//                     "es-CL",
//                   )}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">PUCC Valid Upto</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.puccUpto}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Maker Model</span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {Details?.model}
//                 </span>
//               </div>
//               {/* <div className="rc-div">
//               <span className="rc-property">Vehicle Class</span>
//               <span className="w-10">:</span>
//               <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                { Details?.vehicle_category}
//               </span>
//             </div>  */}
//               <div className="rc-div">
//                 <span className="rc-property" style={{ fontWeight: "700" }}>
//                   Owner Number
//                 </span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {Details?.ownerCount}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Owner</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.owner ? maskName(Details.owner) : ""}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Father Name</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.ownerFatherName
//                     ? maskName(Details.ownerFatherName)
//                     : "-"}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Chassis Number</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {replaceLastFiveCharacters(Details?.chassis)}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Engine Number</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {replaceLastFiveCharacters(Details?.engine)}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Fuel Type </span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {Details?.type}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Color</span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {Details?.vehicleColour}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Emission Norm</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.normsType}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property" style={{ fontWeight: "700" }}>
//                   Manufactured on
//                 </span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {Details?.vehicleManufacturingMonthYear}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Registered Date </span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {new Date(Details?.regDate).toLocaleDateString("es-CL")}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Expiry Date</span>
//                 <span className="w-10">:</span>
//                 <span
//                   className="title ps-2 w-45"
//                   style={{ fontWeight: "500", color: redClr }}
//                 >
//                   {new Date(Details?.rcExpiryDate).toLocaleDateString("es-CL")}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Tax Paid Upto</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.vehicleTaxUpto}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">RTO </span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.regAuthority}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Cubic Capacity</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.vehicleCubicCapacity}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Seating Capacity</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.vehicleSeatCapacity
//                     ? Details?.vehicleSeatCapacity
//                     : "-"}
//                 </span>
//               </div>
//               <div className="rc-div">
//                 <span className="rc-property">Noc Details</span>
//                 <span className="w-10">:</span>
//                 <span className="title ps-2 w-45" style={{ fontWeight: "500" }}>
//                   {Details?.nocDetails ? Details?.nocDetails : "-"}
//                 </span>
//               </div>
//               {/* TOP SERVICE */}
//               <span
//                 className="title  text-center d-flex  justify-content-center flex-column"
//                 style={{ paddingTop: "2px", fontWeight: "700", color: redClr }}
//               >
//                 Top Services
//               </span>

//               <div className="rc-div rc-gird-2">
//                 <Link
//                   to="/MakeCustomizepost"
//                   className="d-flex align-items-start gap-1"
//                 >
//                   {/* <img
//                     src="assets/images/check.png"
//                     style={{ maxHeight: "16px", marginTop: "3px" }}
//                     alt="check"
//                   /> */}

//                   <i
//                     className="bx bx-check"
//                     style={{
//                       maxHeight: "16px",
//                       marginTop: "3px",
//                       color: redClr,
//                       fontWeight: "bold",
//                     }}
//                   ></i>
//                   <span className="rc-property w-100">
//                     Create Professional Social Media Post
//                   </span>
//                 </Link>
//                 <Link className="d-flex align-items-start gap-1">
//                   {/* <img
//                     src="assets/images/check.png"
//                     style={{ maxHeight: "16px", marginTop: "3px" }}
//                     alt=""
//                   />{" "} */}
//                   <i
//                     className="bx bx-check"
//                     style={{
//                       maxHeight: "16px",
//                       marginTop: "3px",
//                       color: redClr,
//                       fontWeight: "bold",
//                     }}
//                   ></i>
//                   <span className="rc-property w-100">Carthi Perfume</span>
//                 </Link>
//               </div>
//               {/* carthi sites */}
//               <div className="rc-gird-2 border-0">
//                 <a
//                   href="https://m.carthi.in/"
//                   className="d-flex align-items-center "
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   <div className="d-flex justify-content-left align-items-center">
//                     <span
//                       className="rc-property w-100"
//                       style={{
//                         color: redClr,
//                       }}
//                     >
//                       m.carthi.in
//                     </span>
//                     <span
//                       class="material-symbols-outlined"
//                       style={{ fontSize: "16px" }}
//                     >
//                       arrow_outward
//                     </span>
//                   </div>
//                 </a>
//                 <a
//                   href="https://carthi.in/"
//                   className="d-flex align-items-center "
//                   target="_blank"
//                   rel="noreferrer"
//                 >
//                   <div className="d-flex justify-content-left align-items-center">
//                     <span
//                       className="rc-property w-100"
//                       style={{
//                         color: redClr,
//                       }}
//                     >
//                       carthi.in
//                     </span>
//                     <span
//                       class="material-symbols-outlined"
//                       style={{ fontSize: "16px" }}
//                     >
//                       arrow_outward
//                     </span>
//                   </div>
//                 </a>
//               </div>
//             </div>
//           ) : (
//             <div
//               className="text-center mt-2"
//               style={{ color: "#ff002a", fontWeight: "500" }}
//             >
//               <label>
//                 {Details?.message ||
//                   "We're working on retrieving the information. Please check back shortly."}{" "}
//               </label>
//             </div>
//           )}
//         </div>

//         {/* our services */}
//         {Code !== 200 && (
//           <>
//             <div className="text-center">
//               <h2 className="page-title">Top Services</h2>
//             </div>
//             <div className="our-service">
//               <div
//                 className="cat-link d-block"
//                 style={{ margin: "0px 0px 15px 0px" }}
//               >
//                 <Link
//                   to="/MakeCustomizepost"
//                   className="d-flex align-items-center gap-2"
//                 >
//                   <img src="assets/images/design-template.png" alt="" />
//                   <label>Create Professional Social Media Post</label>
//                 </Link>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// export default CheckRC;
